import { ColorConf } from "@/config/color";
import { useOnboarding } from "@/contexts/OnboardingContext";
import { Status } from "@/types/status";
import { MAX_WIDTH } from "@/utils/constant";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography
} from "@mui/material";
import { memo } from "react";

interface Props {
  hasMaxWidth?: boolean;
}

const CLAIM_BASIC_PLAN_FREE_IMAGE_URL = "/images/claim-basic-plan-free.svg";

function BannerClaimCampaign({ hasMaxWidth = true }: Props) {
  const { status, handleClaimBasicPlanFree, timeRemaining } = useOnboarding();
  const isClaiming = status === Status.Claiming;

  return (
    <Box
      sx={{
        height: 80,
        width: "100%",
        maxWidth: hasMaxWidth ? MAX_WIDTH : "unset",
        marginInline: "auto",
        position: "relative",
        background: ColorConf.Primary25,
        backdropFilter: "blur(20px)"
      }}
    >
      <Stack
        direction="row"
        height={1}
        gap={1}
        justifyContent="space-between"
        alignItems="center"
        sx={{ paddingX: 1, paddingY: 0 }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              position: "absolute",
              top: 5,
              bottom: "10.406px"
            }}
          >
            <Box
              sx={{
                width: 187,
                height: 24,
                position: "relative"
              }}
            >
              <Box
                component="img"
                src={CLAIM_BASIC_PLAN_FREE_IMAGE_URL}
                alt="add-uraharu"
                sx={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  left: "-28px",
                  top: "5px",
                  transform: "translateZ(0)",
                  backfaceVisibility: "hidden"
                }}
              />
            </Box>
            <Typography
              sx={{
                transform: "rotate(-5deg)",
                color: ColorConf.MonoPrimaryText,
                fontSize: "11px",
                fontWeight: 400,
                lineHeight: "20px",
                letterSpacing: "0.25px",
                width: "200px",
                textAlign: "left"
              }}
            >
              ID認証とプロフィール更新を完了した特典として
            </Typography>
          </Box>
        </Box>
        <Stack direction="column" textAlign="center" gap={0.5}>
          <Button
            variant="contained"
            color="primary"
            type="button"
            disabled={isClaiming}
            startIcon={
              isClaiming ? (
                <CircularProgress size={18} color="inherit" />
              ) : (
                <DoneAllIcon />
              )
            }
            onClick={() => handleClaimBasicPlanFree()}
            sx={{
              height: 40,
              background: `linear-gradient(264deg, ${ColorConf.Accent100} 0%, ${ColorConf.Primary100} 100%)`
            }}
          >
            今すぐ受け取る
          </Button>
          <Typography
            variant="caption"
            sx={{ color: ColorConf.MonoPrimaryText }}
          >
            有効期限: {timeRemaining}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}

export default memo(BannerClaimCampaign);
